import { render, staticRenderFns } from "./app.vue?vue&type=template&id=8a66c704&scoped=true"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=8a66c704&prod&lang=scss&scoped=true"
import style1 from "./app.vue?vue&type=style&index=1&id=8a66c704&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a66c704",
  null
  
)

export default component.exports